<template>
  <div id="ag-grid-demo">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start">
          <div class="form-group has-search ml-3">
            <span class="fa fa-search form-control-company-feedback"></span>
            <input
              @input="SearchUser()"
              id="quickFilter"
              v-model="search_user_name"
              class="filter_input_company form-control-company"

            >
          </div>
        </div>

        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'Company_admin_users_list' })"
          >Create User</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <!--      <div class="mb-4 md:mb-0">-->
      <!--        <per-page-->
      <!--          :currentPerPage="per_page"-->
      <!--          :pageStart="pageStart"-->
      <!--          :pageEnd="pageEnd"-->
      <!--          :total="total"-->
      <!--          @change-per-page="ChangePerPage($event)"-->
      <!--        />-->
      <!--      </div>-->

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        :class="{'noDataTable': !list.length}"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"

        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
import TableMixin from '@/mixins/table.js'
import { AgGridVue } from 'ag-grid-vue'
import {format} from "date-fns";
import CellRendererActions from "./cell-renderer/CellRendererActions";
import CreateUser from "@/views/company-admin/company_users/Users/List";

export default {
  mixins: [TableMixin],
  components: {
    AgGridVue,
    CellRendererActions,
    CreateUser
  },
  data() {
    return {
      search_user_name:"",
      // table header value
      gridOptions: {},
      columnDefs: [
        {
          headerName: 'Username',
          field: 'user_name',
          minWidth: 220
        },
        {
          headerName: 'Created On',
          field: 'created_on',
          minWidth: 220
        },
        {
          headerName: 'Credits',
          field: 'credit',
          minWidth: 220
        },
        {
          headerName: 'Balance ',
          field: 'balance',
          minWidth: 220
        },
        {
          headerName: 'Status',
          field: 'status',
          minWidth: 220
        },
        {
          headerName: 'Action',
          width: 100,
          flex: 0,
          cellRendererFramework: 'CellRendererActions'
        }
      ],
      list: [],

      // Cell Renderer components
      components: {
        CellRendererActions
      },
      searchProduct: ''
    }
  },
  // watch:{
  //   SearchUser: function () {
  //     this.Page = 0;
  //     this.GetList(this.order_dir, this.order_by);
  //   },
  // },
  computed:{
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage:{
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }

    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
  },
  methods: {
    GetList () {
      this.$vs.loading()
      this.$store.dispatch('user/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 20,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
        user_name: this.search_user_name + '*'
      })
        .then(res => {
          console.log(res,"++++++++++++++++")
          this.list = res.items.map(this.TransformList)
          console.log(this.list,"------------------")
          this.total = res.total
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => this.$vs.loading.close())
    },
    SearchUser(){
      this.GetList()
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
      return {
        refreshData: this.GetList,
        user_id: item.user_id,
        credit: item.company.credit,
        status: item.status,
        full_name: item.full_name,
        created_by: item.created_by,
        user_name: item.user_name,
        company_name: item.company_name,
        balance:item.company.balance,
        rank: item.rank === 'Default' ? 'User' : 'Admin',
        created_on: item.created_on && format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
      }
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.sizeColumnsToFit()
  },
  created(){
    this.GetList()
  },
}
</script>

<style scoped>
  .filter_input_company{
    padding: 17px;
    padding-left: 55px;
    width: 220px;
    height: 41px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
    margin-top: 10px;
  }
  .has-search .form-control-company-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    margin-left: 25px;
    margin-top: 25px;
  }
</style>
